import { Injectable } from '@angular/core';
import { IFeaturePermissionProviderService } from '@nimbus-library/features/feature-permission/services/contracts/i-feature-permission-provider.service';
import { IFeatureCollection } from '@nimbus-library/features/feature-permission/models/i-feature-collection.model';
import { GraphPermissionResolver } from '@nimbus-library/features/graph/resolver/graph-permission-resolver';
import { MicrosoftPermission } from '@nimbus-library/features/graph/enums/graph-permission.enum';
import { IFeature } from '@nimbus-library/features/feature-permission/models/i-feature.model';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

@Injectable()
export class FeaturePermissionProviderService extends IFeaturePermissionProviderService {
  protected featureCollectionDefinition: IFeatureCollection[] = [
    {
      name: 'Attendant Console',
      icon: ICONS.ATTENDANT_CONSOLE,
      showName: false,
      features: [
        {
          name: TranslationKeys.FeaturePermissionsBasicSearch,
          description: TranslationKeys.FeaturePermissionsBasicSearchDesc,
          icon: ICONS.O365,
          permissions: [
            {
              adminActionRequired: false,
              displayName: MicrosoftPermission.UserRead,
              permission: MicrosoftPermission.UserRead,
            },
            {
              adminActionRequired: false,
              displayName: MicrosoftPermission.UserReadBasicAll,
              permission: MicrosoftPermission.UserReadBasicAll,
            },
          ],
          provider: GraphPermissionResolver,
        } as IFeature<MicrosoftPermission>,
        {
          name: TranslationKeys.FeaturePermissionsExchangeContactSearch,
          description: TranslationKeys.FeaturePermissionsExchangeContactSearchDesc,
          icon: ICONS.OUTLOOK,
          permissions: [
            {
              adminActionRequired: false,
              displayName: MicrosoftPermission.ContactsRead,
              permission: MicrosoftPermission.ContactsRead,
            },
            {
              adminActionRequired: false,
              displayName: MicrosoftPermission.ContactsReadShared,
              permission: MicrosoftPermission.ContactsReadShared,
            },
          ],
          provider: GraphPermissionResolver,
        } as IFeature<MicrosoftPermission>,
        {
          name: TranslationKeys.FeaturePermissionsCalendarView,
          description: TranslationKeys.FeaturePermissionsCalendarViewDesc,
          icon: ICONS.OUTLOOK,
          permissions: [
            {
              adminActionRequired: false,
              displayName: MicrosoftPermission.CalendarsRead,
              permission: MicrosoftPermission.CalendarsRead,
            },
            {
              adminActionRequired: false,
              displayName: MicrosoftPermission.CalendarsReadShared,
              permission: MicrosoftPermission.CalendarsReadShared,
            },
          ],
          provider: GraphPermissionResolver,
        } as IFeature<MicrosoftPermission>,
        {
          name: TranslationKeys.FeaturePermissionsAdvancedSearch,
          description: TranslationKeys.FeaturePermissionsAdvancedSearchDesc,
          icon: ICONS.O365,
          permissions: [
            {
              adminActionRequired: true,
              displayName: MicrosoftPermission.UserReadAll,
              permission: MicrosoftPermission.UserReadAll,
            },
          ],
          provider: GraphPermissionResolver,
        } as IFeature<MicrosoftPermission>,
        {
          name: TranslationKeys.FeaturePermissionsPresence,
          description: TranslationKeys.FeaturePermissionsPresenceDesc,
          icon: ICONS.O365,
          permissions: [
            {
              adminActionRequired: false,
              displayName: MicrosoftPermission.PresenceReadAll,
              permission: MicrosoftPermission.PresenceReadAll,
            },
          ],
          provider: GraphPermissionResolver,
        } as IFeature<MicrosoftPermission>,
      ],
    },
  ];
}
